import {mergeApplicationConfig, ApplicationConfig, importProvidersFrom} from '@angular/core';
import {appConfig} from './app.config';
import {HttpClient} from "@angular/common/http";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";

const browserConfig: ApplicationConfig = {
  providers: [
    {provide: 'MESSAGE', useValue: 'B'},
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => {
            return new TranslateHttpLoader(http, './i18n/', `.json?v=${Date.now()}`); //had to be changed otherwise everything would have been overwritten
          },
          deps: [
            HttpClient
          ]
        }
      })
    )
  ]
};

export const config = mergeApplicationConfig(appConfig, browserConfig);
